module.exports = __webpack_public_path__ + "img/ax-icon-active.922f8379.svg";